import { View, Text, TouchableOpacity, Platform } from "react-native";
import React, { useEffect, useState } from "react";
import { Audio } from "expo-av";
import { Ionicons } from "@expo/vector-icons";
import MyText from "../../custom/MyText";
import ProgressBar from "../../custom/ProgressBar";
import {
  chatMeSenderBackground,
  chatNotMeSenderBackground,
  gray,
  primary,
  white,
} from "../../../colors";
import MicrophoneIcon from "../../../assets/svg/MicrophoneIcon";
import MessageStatus from "./MessageStatus";

export default function VoiceMessage(props) {
  const { meSender, uri, status, sender } = props;
  const [sound, setSound] = useState(null);
  const [duration, setDuration] = useState(0);
  const [currentProgress, setCurrentProgress] = useState(0);
  const [playing, setPlaying] = useState(false);

  async function setSoundSource() {
    const { sound, status: status1 } = await Audio.Sound.createAsync({
      uri: uri,
    });
    setSound(sound);
    setDuration(+status1.durationMillis);
    //console.log(status1);

    await sound.playAsync();
    if (Platform.OS === "web") {
      // await sound.setOnAudioSampleReceived(({ timestamp }) => {
      //   if (timestamp * 1000 === status.durationMillis) {
      //     sound.unloadAsync();
      //     setPlaying(false);
      //     setSound(null);
      //     setCurrentProgress(0);
      //   } else {
      //     setCurrentProgress(timestamp);
      //   }
      // });
    }
    await sound.setOnPlaybackStatusUpdate((statusData) => {
      const { didJustFinish, positionMillis } = statusData;
      setCurrentProgress(+positionMillis);
      if (didJustFinish) {
        sound.unloadAsync();
        setPlaying(false);
        setSound(null);
        setCurrentProgress(0);
      }
    });
  }
  async function playSound() {
    await sound.playAsync();
    if (Platform.OS === "web") {
      // await sound.setOnAudioSampleReceived(({ timestamp }) => {
      //   console.log("here");
      //   console.log(timestamp, duration);
      //   if (timestamp * 1000 === duration) {
      //     sound.unloadAsync();
      //     setPlaying(false);
      //     setSound(null);
      //     setCurrentProgress(0);
      //   } else {
      //     setCurrentProgress(timestamp);
      //   }
      // });
    }
    await sound.setOnPlaybackStatusUpdate((statusData) => {
      const { didJustFinish, positionMillis } = statusData;
      setCurrentProgress(+positionMillis);
      if (didJustFinish) {
        sound.unloadAsync();
        setPlaying(false);
        setSound(null);
        setCurrentProgress(0);
      }
    });
  }
  async function pauseSound() {
    await sound.pauseAsync();
  }


  return (
    <View
      style={{
        alignItems: meSender ? "flex-start" : "flex-end",
        marginVertical: 10,
      }}
    >
      <View
        style={{
          width: "65%",
          height: 50,
          borderWidth: 1,
          borderRadius: 10,
          marginVertical: 5,
          marginHorizontal: 10,
          flexDirection: meSender ? "row" : "row-reverse",
          alignItems: "center",
          overflow: "hidden",
          borderColor: "#ddd",
          backgroundColor: props.meSender
            ? chatMeSenderBackground
            : chatNotMeSenderBackground,
        }}
      >
        <TouchableOpacity
          onPress={() => {
            if (sound === null) {
              setSoundSource();
              setPlaying(true);
            } else {
              if (playing) {
                pauseSound();
                setPlaying(false);
              } else {
                playSound();
                setPlaying(true);
              }
            }
          }}
          style={{
            transform: [{ rotate: meSender ? "180deg" : "0deg" }],
            marginHorizontal: 5,
          }}
        >
          {playing ? (
            <Ionicons name="pause-outline" size={24} color={gray} />
          ) : (
            <Ionicons name="play" size={24} color={gray} />
          )}
        </TouchableOpacity>
        <View style={{ flex: 1 }}>
          <View style={{ width: "100%", paddingHorizontal: 5 }}>
            {currentProgress > 1 && (
              <ProgressBar
                progress={(currentProgress / duration) * 100}
                color={primary}
              />
            )}
          </View>
        </View>
        <View
          style={{
            padding: 5,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: meSender ? primary : white,
            height: "100%",
          }}
        >
          <MicrophoneIcon color={meSender ? white : primary} />
        </View>
      </View>
      <View
        style={{
          flexDirection: meSender ? "row" : "row-reverse",
          width: "65%",
        }}
      >
        <View style={{ flex: 1 }}></View>
        <MessageStatus meSender={sender === "patient"} status={status} />
      </View>
    </View>
  );
}
